module.exports = __webpack_public_path__ + "img/kz.56f1b893.svg";